import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';

import { ReduxFormField, ReduxFormFieldCheckPopup } from 'components';

const renderField = ({ input, meta, checkType, validate, warn, refPass, ...rest }) => {
  return (
    <Form.Field>
      <Input
        ref={refPass}
        name={input.name}
        value={input.value || rest.defaultValue}
        {...rest}
        onChange={(e, data) => {
          input.onChange(data.value);
        }}
        onBlur={() => {
          input.onBlur();
        }}
        error={rest.error || false}
        className={rest.error ? 'validate-error' : ''}
      />
      <ReduxFormFieldCheckPopup checkType={checkType} {...meta} />
    </Form.Field>
  );
};

const ReduxFormSemanticInput = ({ ...rest }) => {
  return <ReduxFormField component={renderField} {...rest} />;
};

ReduxFormSemanticInput.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  checkType: PropTypes.number
};
ReduxFormSemanticInput.defaultProps = {
  checkType: 99
};

export default ReduxFormSemanticInput;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormSemanticInput.js